(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CoopProposalStatus',
	};

	var $form;
	var $table;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form  = $(form.element);
		$table = $form.find('.table-selectable');

		$table.on(
			'mouseup',
			'tbody tr, li.table-row',
			function rowClicked(e) {
				var action_clicked = false;

				if ($(e.target).is('i')) {
					action_clicked = true;
				}

				selectRow(e.currentTarget, action_clicked);
			}
		);

		function selectRow(row, $action_clicked)
		{
			var $checkbox = $(row).find('input[type=checkbox]:first');

			if ($checkbox.prop('disabled')) {
				if ($action_clicked === false) {
				Adzuki.StatusMessage(null, 'Approved Co-Op proposals cannot be modified');
			}
				$checkbox.prop('checked', false).trigger('change');
				return;
			}
		}
	};
}(jQuery, window.Adzuki || {}));